export const USER_INVITATION_FORM_TAB_NAME_EMAIL = 'email'

export const USER_INVITATION_FORM_TAB_NAME_SMS = 'sms'

export const USER_INVITATION_FORM_FIELD_NAME_MESSAGE = 'message'

export const USER_INVITATION_FORM_FIELD_NAME_SUBJECT = 'subject'

export const USER_INVITATION_FORM_FIELD_WITH_SMS = 'send_sms'

export const USER_INVITATION_FORM_NOTIFICATION_ID_INFO = 'info'

export const USER_INVITATION_FORM_SUBJECT_FIELD_MAX_LENGTH = 256
